import { BuildingOfficeIcon } from '@heroicons/react/24/outline';
import { Badge, Box, Card, Group, Text, ThemeIcon } from '@mantine/core';

interface ExperienceEntry {
  id: string;
  position: string;
  company: string;
  duration: string;
  description: string;
}

interface CVExperienceHighlightsProps {
  experiences: ExperienceEntry[];
  totalCount: number;
}

export function CVExperienceHighlights({ experiences, totalCount }: CVExperienceHighlightsProps) {
  if (experiences.length === 0) {
    return null;
  }

  return (
    <Box>
      <Group mb="xs" gap="xs">
        <ThemeIcon color="brand" variant="light" size="md">
          <BuildingOfficeIcon style={{ width: 16, height: 16 }} />
        </ThemeIcon>
        <Text fw={600}>Experience Highlights</Text>
      </Group>

      <Card shadow="sm" withBorder>
        {experiences.map((exp, index) => (
          <Box 
            key={exp.id} 
            p="sm" 
            style={{ 
              borderBottom: index < experiences.length - 1 ? '1px solid var(--mantine-color-gray-3)' : 'none' 
            }}
          >
            <Group gap="xs" justify="space-between">
              <Text fw={600} size="sm">{exp.position}</Text>
              <Badge size="sm" variant="light">{exp.duration}</Badge>
            </Group>
            <Text size="sm" c="dimmed" mb="xs">{exp.company}</Text>
            <Text size="sm" lineClamp={2} style={{ whiteSpace: 'pre-wrap' }}>{exp.description}</Text>
          </Box>
        ))}

        {totalCount > 3 && (
          <Box p="sm" ta="center">
            <Text size="sm" c="dimmed">
              +{totalCount - 3} more experiences
            </Text>
          </Box>
        )}
      </Card>
    </Box>
  );
}

